import { useEffect } from 'react';
import { isEmpty, keyBy } from 'lodash';

import { useGetPipelineSchemaViolations, useQueryAllSchemas } from '@ion/api';

import { useSchemaViolationsPageContext } from 'app/schema-violations/SchemaViolationsPage/SchemaViolationsPageContextProvider';

import schemaViolationsTableColumns from './schemaViolationsTableColumns';

const STATIC_PROPS = {
  columns: schemaViolationsTableColumns,
  pagination: true,
};

export default function useSchemaViolationsTableProps() {
  const { pipeline: { cluster, writekey } = {}, earliestSeen } = useSchemaViolationsPageContext();
  const [getPipelineSchemaViolations, { loading: violationsLoading, data: violations }] =
    useGetPipelineSchemaViolations();
  const { loading: schemaLoading, data: schemas } = useQueryAllSchemas();

  useEffect(() => {
    getPipelineSchemaViolations({
      earliestSeen,
      clusterId: cluster.id,
      writekey: writekey,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster.id, writekey]);

  const loading = violationsLoading || schemaLoading;

  return {
    ...STATIC_PROPS,
    loading,
    data: loading ? [] : mapViolationsWithSchemaName(violations, schemas),
  };
}

function mapViolationsWithSchemaName(violations, schemas) {
  if (isEmpty(violations)) {
    return violations;
  }

  const schemasById = keyBy(schemas, 'id');

  return violations.map(violation => ({
    ...violation,
    schemaName: schemasById[violation.schemaId]?.name ?? '', // There can be schemas deployed from the CLI
  }));
}
